import SearchStationResultItemSkeleton from './SearchStationResultItemSkeleton';

const SKELETON_WIDTHS = [
	{ title: 'w-32', address: 'w-48', distance: 'w-8' },
	{ title: 'w-44', address: 'w-56', distance: 'w-10' },
	{ title: 'w-36', address: 'w-40', distance: 'w-9' },
];

const SearchStationResultListSkeleton = () => {
	return (
		<section className="flex w-full flex-col">
			<ul className="w-full">
				{SKELETON_WIDTHS.map(({ title, address, distance }) => (
					<SearchStationResultItemSkeleton
						key={`${title}-${address}-${distance}`}
						titleWidthClassName={title}
						addressWidthClassName={address}
						distanceWidthClassName={distance}
					/>
				))}
			</ul>
		</section>
	);
};

export default SearchStationResultListSkeleton;
